import { render } from "./Product.vue?vue&type=template&id=0ae676ae"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TechLHAB\\OneDrive\\Desktop\\WEBAPPS\\VueJs\\ecommerce-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__